import { publicUrlFor } from "../../globals/constants";

function KBImage(props) {
    return(
        <>
            <img {...props} src={publicUrlFor(props.src)} alt={props.alt}/>
        </>
    )
}

export default KBImage;